module.exports = __webpack_public_path__ + "img/character_e.dc6cc75b.svg";